import React, {  useEffect, useState } from 'react';
import {HtmlParse} from 'utils';
import PubSub from 'services/PubSub/';
import Modal from "components/Modal";
import ProductItem from "./ProductItem";
import AddressServices from "services/Address/";
import StorageService from 'services/StorageService/';
import CartService from "services/Cart/";
import Cookies from 'universal-cookie';
import Loader from "components/Loader";
import ListService from "services/AccountLists/";
import CartActions from 'actions/Cart';
import { actionsType } from 'config/constants';
import SalesChannel from 'services/SalesChannel';
import style from './style.scss'; //NOSONAR

let actions = [];

const ModalProductsCart = () => {


    const [currentItems, setCurrentItems] = useState([]);
    const [oldItems, setOldItems] = useState(null);
    const [oldSC, setOldSC] = useState(null);
    const [oldNameSC, setOldNameSC] = useState(null);
    const [oldMethod, setOldMethod] = useState(null);
    const [oldAddress, setOldAddress] = useState(null);
    const [action, setAction] = useState(null);
    const [products, setProducts] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState(false);
    const [title, setTitle] = useState('');
    const [titleButtonSuccess, setButtonSuccess] = useState('');

    useEffect(()=> {
        actions.push(PubSub.register(actionsType.MODAL.PRODUCTS_CART_OPEN, _open));
        return function cleanup () {
            actions.map(token => PubSub.unregister(token));
            actions = [];
        }
    },[])

    const _open = (payload) => {
        if (payload && (payload !== {}) && payload.value) {
            if(typeof window !== 'undefined'){
                window.scrollTo(0,0);
            }
            let value = payload.value;
            setCurrentItems(value.currentItems);
            setOldItems(value.oldItems);
            setOldSC(value.sc);
            setOldNameSC(value.oldNameSC);
            setOldMethod(value.oldMethod);
            setOldAddress(value.oldAddress);
            setAction(value.action);
            setIsLoading(true);
            setMessage(value.message || false);
            setTitle(value.title || '');
            setButtonSuccess(value.buttonSuccess || '');

            let prods = {};
            if (value.currentItems && value.currentItems.length) {
                value.currentItems.map(item => {

                    prods[item.id] = { quantity: item.quantity };

                });
            }

            ListService.productsSkus(prods, value.sc ? value.sc : false).then(response => {
                if (!response) return;

                setProducts(response)
                setIsLoading(false);

            });
        }
    }

    const restore = () => {


        let items = currentItems;
        items = items.concat(oldItems);

        setIsLoading(true);
        StorageService.setSecureItem('sales_channel', oldSC);
        if(oldMethod === 'seller-1-sla-DespachoaDomicilio') {
            AddressServices.applyAddress(oldAddress, [oldAddress], oldSC).then(orderFrm => {
                if(orderFrm){
                    CartService.updateOrderForm(items, oldSC).then(() => {
                        AddressServices.setDeliveryMode(oldMethod,  oldNameSC, oldSC, false, false).then(newOrderForm=>{
                            StorageService.removeItem('productsRemoved');

                            setIsLoading(false);
                            CartActions.updateOrderForm(newOrderForm).then(()=>{
                                PubSub.dispatch('change_delivery_mode');
                            });
                            _close();
                        })
                    });
                }
            })
        } else {
            CartService.updateOrderForm(items, oldSC).then(() => {
                AddressServices.setDeliveryMode(oldMethod,  oldNameSC, oldSC, false, false).then((orderForm)=>{
                    StorageService.removeItem('productsRemoved');

                    setIsLoading(false);
                    CartActions.updateOrderForm(orderForm);
                    _close();
                })
            });
        }
    }

    const _close = () => {
        setTimeout(() => PubSub.dispatch(actionsType.MODAL.PRODUCTS_CART_CLOSE),0);
    }

    const getFormatedMethod = (method) => {
        switch(method){
            case 'seller-1-sla-RetiroenTienda':
                return "Retiro en Tienda";
            case 'seller-1-sla-ClickalAuto':
                return "Retiro en el Auto";
            case 'seller-1-sla-DespachoaDomicilio':
                return "Despacho a domicilio";
            default:
                return '';
        }
    }

    const text = (action === 'view') ? 'en esta compra' : 'no disponibles';
    let textButtonRecover = '';
    const cookies = new Cookies();
    const currentStore = cookies.get('store-name', { path: '/', domain: 'localhost' });
    const currentShippingMethod = SalesChannel.getMethodName();

    if(action === 'restore') {
        if(currentShippingMethod !== oldMethod) {
            textButtonRecover = 'Mantener ' + getFormatedMethod(currentShippingMethod);
        } else {
            textButtonRecover = 'Mantener ' + currentStore;
        }

        if(currentShippingMethod === 'seller-1-sla-DespachoaDomicilio' && currentShippingMethod === oldMethod) {
            textButtonRecover = 'Mantener dirección actual';
        }
    } else {
        textButtonRecover = 'Aceptar';
    }

    return (
        <Modal customClass={'modal-products-cart header-checkout'} actionOpen={actionsType.MODAL.PRODUCTS_CART_OPEN} actionClose={actionsType.MODAL.PRODUCTS_CART_CLOSE}>
            <div className="new-modal-container">
                <div className="new-modal-scroll">

                    <div className={"wrap-products-cart"}>
                        {isLoading && <div className="wrap-products-cart-loader"><Loader/></div>}
                        <div className="new-modal-title">
                            <span className="modal-products-cart-text" ><span className="text-bold-available">{!title ? `Productos ${text}` : title}</span></span>
                        </div>
                        {message && <span className="modal-products-message"> {HtmlParse(message)} </span>}
                        {(action === 'restore') && <p className="products-cart-msg">Estos productos han sido eliminados de tu carro de compras al haber hecho
                            <span className="products-cart-msg-strong"> cambio de modo de entrega.</span>
                            <span className="products-cart-msg-highlighted">Si quieres recuperarlos, vuelve al modo de entrega anterior.</span>
                        </p>}
                        {(products && products.length !== 0) && products.map((product, i) =>
                            <ProductItem key={i + product.productId} product={product} />
                        )}
                    </div>
                </div>


                <div className="modal-actions" >
                    {(action === 'restore') && <button className={"primary-btn modal-confirmation-cart" + ((action === 'restore') ? ' restore': '') + (isLoading ? ' disabled-btn ' : '')} onClick={restore}>Recuperar productos</button>}
                    <button className={"primary-btn modal-confirmation-cart" + ((action === 'restore') ? ' secondary': '')} onClick={_close}>{titleButtonSuccess ? titleButtonSuccess : textButtonRecover}</button>
                </div>

            </div>
        </Modal>
    );

}

export default ModalProductsCart;
